<div formGroupName="caseEscalation" class="row form-wrapper">
  <div class="col-12">
    <app-datepicker-form-field formControlName="escalatedDate"
      [label]="'case.fields.escalatedDate.label' | translate"
      [helpText]="'case.fields.escalatedDate.help'"
      [viewMode]="viewMode"></app-datepicker-form-field>
  </div>
  <div class="col-12">
    <app-checkbox-form-field formControlName="customerEscalated"
      [label]="'case.fields.customerEscalated.label' | translate"
      [helpText]="'case.fields.customerEscalated.help'"
      [viewMode]="viewMode"
      (onChangeCheckboxEvent)="onCheckEscalateCustomer($event)"
    ></app-checkbox-form-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field formControlName="deEscalatedDate"
      [label]="'case.fields.deEscalatedDate.label' | translate"
      [helpText]="'case.fields.deEscalatedDate.help'"
      [viewMode]="viewMode"></app-datepicker-form-field>
  </div>
  <div class="col-12">
    <app-datepicker-form-field formControlName="customerEscalatedDate"
      [label]="'case.fields.customerEscalatedDate.label' | translate"
      [helpText]="'case.fields.customerEscalatedDate.help'"
      [viewMode]="viewMode"></app-datepicker-form-field>
  </div>
  <div class="col-12">
  <app-configuration-select-form-field
    formControlName="escalationCategory"
    [label]="'case.fields.escalationCategory.label' | translate"
    [helpText]="'case.fields.escalationCategory.help'"
    [placeholder]="'placeholders.please_select'"
    [clearable]="true"
    [searchable]="true"
    [viewMode]="false"
    [externalSearch]="true"
    [params]="{
      type: dropdownType,
      entry1: form.get('escalationCategory')?.value || ''
    }"
    [entry]="entry1"
    [isRequired]="customerEscalated"
    [viewMode]="viewMode"
  ></app-configuration-select-form-field>
  </div>
  <div class="col-12">
      <app-select-form-field
        formControlName="customerEscalatedByWhomInternal"
        [label]="'case.fields.customerEscalatedByWhomInternal.label' | translate"
        [helpText]="'case.fields.customerEscalatedByWhomInternal.help'"
        [placeholder]="'placeholders.please_select'"
        [clearable]="true"
        [searchable]="true"
        [items]="customerInternalUsers"
        [bindValue]="''"
        [bindLabel]="'fullName'"
        [viewMode]="true"
        [externalSearch]="true"
        (onSearchEvent)="searchUsers('search', $event.term, 'customerInternalUsers', $event.page, $event.take)"
        (onScrollEvent)="searchUsers('scroll', $event.term, 'customerInternalUsers', $event.page, $event.take)"
      ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-input-form-field
        formControlName="customerEscalatedByWhomExternal"
        [label]="'case.fields.customerEscalatedByWhomExternal.label' | translate"
        [helpText]="'case.fields.customerEscalatedByWhomExternal.help'"
        [translatable]="false"
        [viewMode]="true"
    ></app-input-form-field>
  </div>
  <div class="col-12">
      <app-select-form-field
        class="disabled-select"
        formControlName="escalationTeam"
        [label]="'case.fields.escalationTeam.label' | translate"
        [helpText]="'case.fields.escalationTeam.help'"
        [placeholder]="'placeholders.please_select'"
        [multipleSelect]="true"
        [users]="true"
        [searchable]="true"
        [items]="escalationTeamUsers"
        [bindValue]="''"
        [bindLabel]="'fullName'"
        [infoText]="''"
        [customClass]="'watchers-view disabled-select'"
        [isRequired]="customerEscalated"
        [externalSearch]="true"
        (onSearchEvent)="searchUsers('search', $event.term, 'escalationTeamUsers', $event.page, $event.take)"
        (onScrollEvent)="searchUsers('scroll', $event.term, 'escalationTeamUsers', $event.page, $event.take)"
      ></app-select-form-field>
  </div>
  <div class="col-12">
    <app-textarea-form-field formControlName="reasonForEscalation"
      [label]="'case.fields.reasonForEscalation.label' | translate"
      [helpText]="'case.fields.reasonForEscalation.help'"
      [viewMode]="viewMode" [isRequired]="customerEscalated"></app-textarea-form-field>
  </div>
</div>
